<div class="d-flex w-100">
	<div class="d-flex flex-column w-100 mx-auto">
		<app-venue-list [ooVenueList]="ooVenueList"></app-venue-list>
	</div>
</div>
